import React, { useEffect, useState } from 'react'
import { claimFormSync, claimFormLoadById } from '../../../../redux/actions/order/claimFormActions'
import { connect, useDispatch } from 'react-redux'
import { getInsuranceFromRPAServices } from '../../../../containers/authorised/addOns/other/AddOnsHelperFunctions'
import { visionInsuranceServicesLoad } from '../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction'
import { visionInsuranceClaimFormCreate, visionInsuranceClaimFormLoad, visionInsuranceClaimFormEdit } from '../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import { ediClearingHouseServicesLoad } from '../../../../redux/actions/addOns/EDIClearingHouse/EdiClearningHouseActions'
import { orderLoad } from '../../../../redux/actions/order/orderActions'

function ClaimFormSync(props) {
  const { order, label, handleAfterSyncSuccessfully, services, claimFormId, inModal, selectedOrderInsurance, editing } = props
  const dispatch = useDispatch()
  const [syncing, setSyncing] = useState(false)
  const ordersInsuranceId = selectedOrderInsurance?.id || editing?.orders_insurance_id
  const orderInsurance = order.orders_insurances_attributes?.find((item) => item.id === ordersInsuranceId)

  useEffect(() => {
    let storeID = localStorage.getItem('StoreID')
    if (storeID == null) {
      dispatch(visionInsuranceServicesLoad({ store_id: order.store_id, category: "vision_insurance" }))
      dispatch(ediClearingHouseServicesLoad({ store_id: order.store_id, category: "edi_clearing_house" }))
    }
  }, [])

  const handleClaimFormSync = async () => {
    if (syncing) return
    setSyncing(true)
    try {
      if (orderInsurance?.visionary_insurance_claim_form_id) {
        const patientInsurance = orderInsurance.patient_insurance_attributes
        const insurance = getInsuranceFromRPAServices(services, patientInsurance?.insurance_name)
        await dispatch(visionInsuranceClaimFormCreate({
          sync_claim_form: true,
          add_ons_id: insurance.id,
          orders_order_id: order.id,
          orders_insurance_id: ordersInsuranceId,
          patient_id: order.patient_id,
          insurance_type: patientInsurance?.insurance_type,
          store_id: order.store_id,
          insurance_payer: patientInsurance?.insurance_name,
          service: insurance.config.service,
          other_details: { resource: 'generate_claim' },
        }))
        handleAfterSyncSuccessfully && handleAfterSyncSuccessfully()
        dispatch(visionInsuranceClaimFormEdit({ orders_insurance_id: ordersInsuranceId }))
        await dispatch(visionInsuranceClaimFormLoad(order.id, {
          include: '*',
          orders_insurance_id: ordersInsuranceId,
        }))
        return
      }

      const syncRes = await dispatch(claimFormSync(order.id, claimFormId))
      const syncedClaimForm = syncRes?.value?.data?.insurance_claim_form
      const newClaimFormId = syncedClaimForm?.id || claimFormId

      await dispatch(orderLoad(order.id, { include: '*' }))
      if (newClaimFormId) {
        await dispatch(claimFormLoadById(order.id, newClaimFormId, { include: '*' }))
      }
      handleAfterSyncSuccessfully && handleAfterSyncSuccessfully()
    } finally {
      setSyncing(false)
    }
  }

  return (
    <button
      type="button"
      className={`btn btn-outline-primary ${inModal ? 'text-nowrap my-0 ml-md-3' : 'ml-md-5 my-md-2 my-lg-0'}`}
      onClick={handleClaimFormSync}
      disabled={syncing}
    >
      {syncing ? 'Syncing...' : (label ?? 'Sync Data')}
    </button>
  )
}

const mapStateToProps = (state, ownProps) => {
  const { order: { order }, visionInsurance: { services }, claimForm: { insurance_claim_form }, visionInsuranceClaimForm: { editing } } = state
  const ordersInsuranceId = ownProps.selectedOrderInsurance?.id || editing?.orders_insurance_id
  const orderInsurance = order.orders_insurances_attributes?.find((item) => item.id === ordersInsuranceId)

  return {
    order,
    services,
    editing,
    claimFormId: orderInsurance?.claim_form_id || insurance_claim_form?.id,
  }
}

export default connect(mapStateToProps)(ClaimFormSync)
